import { MutationKeyConfig, QueryKeyConfig } from '../api-helper';

export interface ManagementRequestArgs {
  fromDate?: string;
  toDate?: string;
  workOrderStatusID?: number;
  dateCriteria?: string;
}

const getManagementQueryStrings = (args: ManagementRequestArgs) => {
  const { fromDate, toDate, workOrderStatusID, dateCriteria } = args;
  let queryString = '';

  if (fromDate) {
    queryString += `${queryString ? '&' : ''}FromDate=${fromDate}&DateCriteria=${dateCriteria}`;
  }
  if (toDate) {
    queryString += `${queryString ? '&' : ''}ToDate=${toDate}`;
  }
  if (workOrderStatusID) {
    queryString += `${queryString ? '&' : ''}WorkOrderStatusID=${workOrderStatusID}`;
  }
  return queryString;
};

export const operationManagementApiKeyStore = {
  updateOperationManagement: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_OPERATION_MANAGEMENT`],
    route: `/OperationManagementQueue/UpdateWorkOrderStatus`,
    action: 'POST',
  }),
  getWorkOrders: (args: ManagementRequestArgs): QueryKeyConfig => ({
    queryKey: [`GET_WORK_ORDERS`, ...[args.fromDate, args.toDate, args.workOrderStatusID].filter((a) => a)],
    route: `/OperationManagementQueue/GetGeneralWorkOrders?${getManagementQueryStrings(args)}`,
  }),
  getOperationManagementInspections: (): MutationKeyConfig => ({
    mutationKey: [`GET_OPERATION_MANAGEMENT_INSPECTIONS`],
    route: `/OperationManagementQueue/GetInspections`,
    action: 'POST',
    disableSnackbar: true
  }),
  getOperationManagementCounts: (): MutationKeyConfig => ({
    mutationKey: [`GET_OPERATION_MANAGEMENT_COUNTS`],
    route: `/OperationManagementQueue/GetQueueCounts`,
    action: 'POST',
    disableSnackbar: true
  }),
};
